(function() {
	'use strict';

	angular
		.module('humbertContainer')
		.controller('ContainerCalcController', ContainerCalcController);

	ContainerCalcController.$inject = ['$stateParams','$window','ContainerService'];

	/* @ngInject */
	function ContainerCalcController($stateParams,$window,ContainerService) {
		var salesTax,
			vm = this;

		vm.title = 'ContainerCalcController';

		vm.fractions = {};
		vm.fractionKey = $stateParams.fractionKey,

		vm.containerTypes = {};
		vm.containerTypeKey = $stateParams.containerTypeKey;

		vm.to = ($stateParams.to === '')?
			null:
			parseFloat($stateParams.to);

		vm.freightZones = {};
		vm.freightZoneKey = $stateParams.freightZoneKey;

		vm.calculation = {};

		vm.emailData = {
			article: {
				fractionKey: vm.fractionKey,
				containerTypeKey: vm.containerTypeKey,
				to: vm.to,
				freightZoneKey: vm.freightZoneKey
			},
			calculation: vm.calculation,
			addressEqDeliveryAdress: false,
			billing: {
				requestType: null,
				customerId: null,
				org: null,
				streetAddress: null,
				city: null,
				name: null,
				tel: null,
				fax: null,
				email: null
			},
			delivery: {
				streetAddress: null,
				city: null,
				name: null,
				tel: null
			},
			info: {
				text: null,
				publicArea: null
			},
			desiredDate: {
				date: null,
				time: null
			}
		};

		vm.messages = [];

		vm.extendedFractionDisplayName = function() {
			var fractionKey, fraction;

			fractionKey = vm.fractionKey;

			if (angular.isDefined(vm.fractions[fractionKey])) {
				fraction = vm.fractions[fractionKey];

				return fractionKey + ' | ' + fraction.displayName;
			}

			return null;
		};

		vm.containerTypeDisplayName = function() {
			var containerTypeKey, containerType;

			containerTypeKey = vm.containerTypeKey;

			if (angular.isDefined(vm.containerTypes[containerTypeKey])) {
				containerType = vm.containerTypes[containerTypeKey];

				return containerType.displayName;
			}

			return null;
		};

		vm.freightZoneDisplayName = function() {
			var freightZoneKey, freightZone;

			freightZoneKey = vm.freightZoneKey;

			if (angular.isDefined(vm.freightZones[freightZoneKey])) {
				freightZone = vm.freightZones[freightZoneKey];
				return freightZone.displayName;
			}

			return null;
		};

		vm.calculationType = function() {
			var fractionKey,
				fraction;

			if (vm.freightZoneKey == 4) {
				return null;
			}

			fractionKey = vm.fractionKey;

			if (angular.isDefined(vm.fractions[fractionKey])) {
				fraction = vm.fractions[fractionKey];

				if (fraction.billingByTons) {
					return 'BY_TONS';
				} else {
					return 'FIXED_PRICE';
				}
			}

			return null;
		};

		vm.invalidInput = function(inputName) {
			return vm.requestForm[inputName].$invalid && vm.requestForm[inputName].$touched
		};

		vm.reset = function() {
			vm.emailData = {
				article: {
					fractionKey: vm.fractionKey,
					containerTypeKey: vm.containerTypeKey,
					to: vm.to,
					freightZoneKey: vm.freightZoneKey
				},
				calculation: vm.calculation,
				addressEqDeliveryAdress: false,
				billing: {
					requestType: null,
					customerId: null,
					org: null,
					streetAddress: null,
					city: null,
					name: null,
					tel: null,
					fax: null,
					email: null
				},
				delivery: {
					streetAddress: null,
					city: null,
					name: null,
					tel: null
				},
				info: {
					text: null,
					publicArea: null
				},
				desiredDate: {
					date: null,
					time: null
				}
			};

			vm.requestForm.$setPristine();
			vm.requestForm.$setUntouched();
		};

		vm.submit = function() {
			ContainerService.post(vm.emailData).then(function(result) {
				vm.messages.push(result.data.message);
				vm.requestForm.$setPristine();
				vm.requestForm.$setUntouched();
			});
		};

		vm.print = function() {
			$window.print()
		};

		activate();

		////////////////

		function activate() {
			getData();
		}

		function getData() {
			ContainerService.get().then(function(data) {
				salesTax = data.salesTax;
				vm.fractions = data.fractions;
				vm.containerTypes = data.containerTypes;
				vm.freightZones = data.freightZones;
				
				calculate();
			});
		}

		function calculate() {
			var fractionKey,
				fraction,
				containerTypeKey,
				freightZoneKey,
				tmpObject;

			fractionKey = vm.fractionKey;
			containerTypeKey = vm.containerTypeKey;
			freightZoneKey = vm.freightZoneKey;

			if (angular.isDefined(vm.fractions[fractionKey])) {
				fraction = vm.fractions[fractionKey];

				if (
					fraction.billingByTons
					&&
					angular.isDefined(vm.fractions[fractionKey])
					&&
					angular.isDefined(vm.fractions[fractionKey]
						.freightZones[freightZoneKey])
				) {
					var totalCostsNetto;

					tmpObject = vm.fractions[fractionKey]
						.freightZones[freightZoneKey];

						
					vm.calculation.transportCosts = tmpObject.transportCosts;
					vm.calculation.exploitationCosts = tmpObject.exploitationCosts;
					vm.calculation.totalExploitationCosts = tmpObject.exploitationCosts * vm.to;
					
					vm.calculation.feeCosts = tmpObject.feeCosts;

					totalCostsNetto = vm.calculation.transportCosts + vm.calculation.totalExploitationCosts + vm.calculation.feeCosts;

					vm.calculation.totalCostsBrutto = totalCostsNetto / 100 * (100 + salesTax);
					vm.calculation.totalCostsNetto = totalCostsNetto;
					vm.calculation.totalCostsTara = totalCostsNetto / 100 * salesTax;

				} else if (
					!fraction.billingByTons
					&&
					angular.isDefined(vm.fractions[fractionKey])
					&&
					angular.isDefined(vm.fractions[fractionKey]
						.containerTypes[containerTypeKey])
					&&
					angular.isDefined(vm.fractions[fractionKey]
						.containerTypes[containerTypeKey]
						.freightZones[freightZoneKey])
				) {
					var totalCostsBrutto;

					tmpObject = vm.fractions[fractionKey]
						.containerTypes[containerTypeKey]
						.freightZones[freightZoneKey];

					totalCostsBrutto = tmpObject.price;

					vm.calculation.totalCostsBrutto = totalCostsBrutto;
					vm.calculation.totalCostsNetto = (totalCostsBrutto / (100 + salesTax)) * 100;
					vm.calculation.totalCostsTara = (totalCostsBrutto / (100 + salesTax)) * salesTax;
				}
			}
		}
	}
})();